export var SixDoFMode;
(function (SixDoFMode) {
    SixDoFMode["ThreeDoF"] = "ThreeDoF";
    SixDoFMode["SixDoF"] = "SixDoF";
})(SixDoFMode || (SixDoFMode = {}));
